<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 5.5C11 4.672 10.328 4 9.49999 4V4C8.67199 4 7.99999 4.672 7.99999 5.5V11V14L6.09899 12.099C5.49199 11.492 4.50799 11.492 3.90099 12.099V12.099C3.37699 12.623 3.29599 13.444 3.70699 14.06L7.21899 19.328C8.33199 20.997 10.205 22 12.211 22H14C17.314 22 20 19.314 20 16V11V7.5C20 6.672 19.328 6 18.5 6V6C17.672 6 17 6.672 17 7.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 5.5C14 4.672 14.672 4 15.5 4V4C16.328 4 17 4.672 17 5.5V12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 12V3.5C14 2.672 13.328 2 12.5 2V2C11.672 2 11 2.672 11 3.5V12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
